// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addStyle[data-v-b6aa4476] {\n  color: #00A551;\n  cursor: pointer;\n  font-size: 18px;\n}\n.deleteStyle[data-v-b6aa4476] {\n  color: #F56C6C;\n  cursor: pointer;\n  font-size: 18px;\n}", ""]);
// Exports
module.exports = exports;
